import { useEffect } from "react";
import useLenisSmoothScroll from "@/lib/lenis";
import Nav from "@/components/chalann/Nav";
import Hero from "@/components/chalann/Hero";
import Marquee from "@/components/chalann/Marquee";
import Manifesto from "@/components/chalann/Manifesto";
import Trimodal from "@/components/chalann/Trimodal";
import Photography from "@/components/chalann/Photography";
import Savings from "@/components/chalann/Savings";
import Pricing from "@/components/chalann/Pricing";
import FinalCTA from "@/components/chalann/FinalCTA";

export default function Landing() {
  useLenisSmoothScroll();

  useEffect(() => {
    document.title = "CHALANN · POS por voz para tu tienda";
  }, []);

  return (
    <main className="relative bg-[#050505] text-white" data-testid="landing">
      <div className="grain-overlay" />
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Trimodal />
      <Photography />
      <Savings />
      <Pricing />
      <FinalCTA />
    </main>
  );
}
